module.exports = __webpack_public_path__ + "static/img/16-2.771c498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16-2.jpg
// module id = 6n38
// module chunks = 0